import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  checkedLabel?: string;
  uncheckedLabel?: string;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, checkedLabel = "已上架", uncheckedLabel = "未上架", ...props }, ref) => (
  <div className="relative inline-flex items-center">
    <SwitchPrimitives.Root
      className={cn(
        "peer inline-flex h-6 w-16 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        className
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-10 data-[state=unchecked]:translate-x-0"
        )}
      />
    </SwitchPrimitives.Root>
    <span className={cn(
      "absolute top-1/2 -translate-y-1/2 text-[10px] font-medium pointer-events-none transition-all whitespace-nowrap",
      props.checked ? "left-1.5 text-white" : "right-1.5 text-muted-foreground"
    )}>
      {props.checked ? checkedLabel : uncheckedLabel}
    </span>
  </div>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
